import type { Component, Image } from '@wix/thunderbolt-becky-types'
import type { ResolvedSVGItem, ResolvedCursorDataItem } from '@wix/thunderbolt-catharsis'
import { encodeSVG } from '@wix/thunderbolt-commons'
import { createCssCompNode } from '../cssCompNode'
import type { FeatureRefs } from '../cssFeatures.types'
import { toBreakpointVariantsMap } from '../../utils/toBreakpointVariantsMap'
import { isImage, isSVGItem } from '../../utils/is'
import { isRefArray } from '../../utils/variantsUtils'

const MAX_SIZE = 128

export const cursor = createCssCompNode('cursor', 'cursor', {
	getDependencies: (component: Component, refs: FeatureRefs<'cursor'>) => refs.cursorQuery(component.cursorQuery!),
	toViewItem: (__, deps) => {
		if (!deps) {
			return null
		}

		const items = isRefArray(deps) ? deps.values : [deps]
		return toBreakpointVariantsMap(items, cursorDataToCss)
	},
})

const cursorDataToCss = (cursorData: ResolvedCursorDataItem) => {
	const { width = MAX_SIZE, height = MAX_SIZE, offsetX, offsetY, media } = cursorData
	if (!media) {
		return null
	}

	const path = getCursorPath(media, width, height)
	const hasOffsets = !!offsetX || !!offsetY

	return path ? { cursor: `${path}${hasOffsets ? ` ${offsetX} ${offsetY}` : ''}, auto` } : null
}

const getCursorPath = (media: Image | ResolvedSVGItem, width: number, height: number) => {
	if (isSVGItem(media)) {
		return getSvgPath(media, width, height)
	}
	if (isImage(media)) {
		return getImagePath(media, width, height)
	}
	return null
}

const getImagePath = (item: Image, width: number, height: number) => {
	const { uri } = item
	return `url(https://static.wixstatic.com/media/${uri}/v1/fill/w_${width},h_${height}/${uri})`
}

const WIDTH_REGEX = /((<svg[^>]+)width="[^"]+"|(<svg[^>]+))/i
const HEIGHT_REGEX = /((<svg[^>]+)height="[^"]+"|(<svg[^>]+))/i

const getSvgPath = (item: ResolvedSVGItem, width: number, height: number) => {
	const { svgId, resolvedSvg } = item
	const svgContent = resolvedSvg?.content || `<svg data-svg-id="fallback-${svgId}" />`

	return encodeSVG(
		svgContent.replace(HEIGHT_REGEX, `$2$3 height="${height}"`).replace(WIDTH_REGEX, `$2$3 width="${width}"`)
	)
}
